/** A hit as `GET /search` sends it, and where the app opens it. */

export type HitKind = 'client' | 'person' | 'project' | 'task' | 'piece' | 'bucket' | 'item'

export interface Hit {
  kind: HitKind
  id: string
  title: string
  subtitle: string
  client_id: string | null
  /** For something inside a bucket: the bucket it is in. */
  parent_id?: string
}

/** What each kind is called in the results, so the groups read as screens do. */
export const HIT_GROUP: Record<HitKind, string> = {
  client: 'Clients',
  project: 'Projects',
  bucket: 'Buckets',
  item: 'Buckets',
  person: 'Team',
  task: 'Tasks',
  piece: 'Content'
}

/**
 * Where following a hit goes.
 *
 * A task and a piece have no page of their own, so they go to the list they
 * live on rather than nowhere; something inside a bucket goes to the bucket.
 */
export function hitPath(hit: Hit): string {
  switch (hit.kind) {
    case 'client':
      return `/clients/${encodeURIComponent(hit.id)}`
    case 'person':
      return `/people/${encodeURIComponent(hit.id)}`
    case 'project':
      return `/projects/${encodeURIComponent(hit.id)}`
    case 'bucket':
      return `/buckets/${encodeURIComponent(hit.id)}`
    case 'item':
      return `/buckets/${encodeURIComponent(hit.parent_id ?? '')}`
    case 'task':
      return '/tasks'
    case 'piece':
      return '/board'
  }
}
